export default {
  get_all: { method: "get", url: "api/units" },
  show: { method: "get", url: "api/units{/id}" },
  store: { method: "post", url: "api/units" },
  update: { method: "put", url: "api/units{/id}" },
  delete: { method: "delete", url: "api/units{/id}" }
};
